import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ScoreboardModel } from 'src/app/models/Scoreboard';
import { GameService } from 'src/app/services/game.service';

@Component({
  selector: 'app-scoreboard',
  templateUrl: './scoreboard.component.html',
  styleUrls: ['./scoreboard.component.css']
})
export class ScoreboardComponent implements AfterViewInit, OnDestroy {

  public scoreboards: ScoreboardModel[] = [];
  public todayDate = new Date();
  private refreshInterval: any = null;
  @Output() onData: EventEmitter<boolean> = new EventEmitter();
  constructor(private gameService: GameService) { }

  ngOnDestroy(): void {
    if(this.refreshInterval !== null){
      clearInterval(this.refreshInterval);
    }
  }

  ngAfterViewInit(): void {
    this.requestScoreboard();
    this.refreshInterval = setInterval(() => {
      this.requestScoreboard();
    }, 15000);
  }

  private requestScoreboard(){
    this.gameService.getScoreboard(this.todayDate).subscribe({
      next:(scoreboards) =>{
        this.scoreboards = scoreboards;
        this.onData.emit(this.scoreboards.length > 0);
      }, error:(err) => { 
        this.onData.emit(false);
      }
    });
  }

}
